import { httpService } from 'src/services';
import { ApiUrl } from 'src/constants';
import { HydraResponse } from 'src/api/hydraResponse';
import { IUsers } from 'src/typings/user';

export function getComplexUsers(token: string = '', getParams: string): Promise<HydraResponse<IUsers[]>> {
  return httpService.get(`${ApiUrl.getApiUrl().getUsersIdInfo}?${getParams}`, {}, {
    Authorization: `Bearer ${token}`,
  });
}
